module.exports = __webpack_public_path__ + "static/media/Rectangle 35.b7b70f3b.svg";